/**
 * Class for the theme itself.
 *
 * @class      Theme (name)
 */
export class Theme
{
	/**
	 * Adds the necessary event listeners.
	 */
	static addListeners()
	{
		// Wait for DOMContentLoaded
		$( document ).ready(
			function()
			{
			}
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/plugins/theme.js